export default __webpack_public_path__ + "static/pana-1-3ecda335091f79f3bfe70acfeb061d53.png";